import { orgLibraryStoreApp, orgLibraryStorePhy } from 'stores/orgLibrary'
import { uploadStatusStore } from 'stores/uploadStatus'

export function handleUploadOrgDataMessage(data) {
  if (data.notify) {
    orgLibraryStorePhy.refetch()
    orgLibraryStoreApp.refetch()
    uploadStatusStore.refetch('ORGANIZATION_DATA')
  }
}
